const textFieldFormEquip = {
  serialNumber: 'Número de Série',
  brand: 'Marca do Equipamento',
  name: 'Especificações do Equipamento',
  reference: 'Ponto de Referência',
  amount: 'Valor',
  acquisitionDate: 'Data de Aquisição',
  residualValue: 'Valor Residual',
};

export default textFieldFormEquip;

